import React, { useEffect, useState } from 'react';
import Portfolio from '../Portfolio';
import FunFact from '../FunFact';
import Hero from '../Hero';
import Div from '../Div';
import { Icon } from '@iconify/react';
import SectionHeading from '../SectionHeading';
import Spacing from '../Spacing';
import Cta from '../Cta';
import LogoList from '../LogoList';
import MovingText from '../MovingText';
import PostSlider from '../Slider/PostSlider';
// import TestimonialSlider from '../Slider/TestimonialSlider';
import VideoModal from '../VideoModal';
import TimelineSlider from '../Slider/TimelineSlider';
import { pageTitle } from '../../helper';

export default function Home() {
  pageTitle('Home');
  const [itemShow, setItemShow] = useState(6);

  // Hero Social Links
  // const heroSocialLinks = [
  //   {
  //     name: 'Behance',
  //     links: '/',
  //   },
  //   {
  //     name: 'Twitter',
  //     links: '/',
  //   },
  // ];

  // FunFact Data
  const funfaceData = ""
  
  const portfolioData = [
    {
      title: 'Bespoke Website and App Development',
      subtitle: 'Through immersive website and application development, data-driven design, cutting-edge AI applications, and more, we provide customized solutions tailored to each client’s unique needs and vision. Our technical knowledge combined with an empathy-focused approach allows us to craft websites that tell compelling brand stories while driving real business impact.<br /> Leveraging our technical expertise along with a data driven approach, we craft immersive websites, intelligent applications, and compelling designs that tell brand stories while generating real business impact. By combining cutting-edge innovations like AI with a deep focus on the end-user experience, we create digital products and platforms that engage audiences, resonate with purpose, and drive results. Our tailored solutions pair performance with meaning to help brands thrive in the digital landscape.',
      href: '/service#bespoke-website-and-app-development',
      src: '/images/service1.webp',
      category: 'ui_ux_design',
    },
    {
      title: 'Strategic Consulting for Digital Transformation ',
      subtitle: "For companies navigating the digital landscape, our expert consultants become trusted partners dedicated to fueling your online growth. We conduct in-depth market research and data analysis to develop fully customized strategic plans aligned with your specific business needs and goals, and our consulting services include competitive benchmarking, customer journey mapping, tailored content and social media strategies, comprehensive SEO audits with technical optimization, ad campaign management backed by robust analytics, and more. By proactively identifying the latest trends and opportunities, we empower brands to conquer the digital world with confidence. Our ongoing guidance enables consistent strategy implementation as conditions evolve, leveraging real-time insights to adapt and thrive in a dynamic online environment. With our support, you gain the actionable insights and proven digital strategies to accelerate growth.",
      href: '/service#strategic-consulting-for-digital-transformation',
      src: '/images/service2.webp',
      category: 'mobile_apps',
    },
    {
      title: 'Voice Search Optimization',
      subtitle: 'RLAB Group empowers businesses of all sizes to confidently adopt AI, driving real innovation and tangible results. Our data scientists and engineers become trusted partners, working closely with you to craft tailored solutions that solve your most pressing real-world challenges, and our end-to-end services span consulting on AI strategy, ethics, and roadmapping. We build custom AI applications for needs like predictive analytics and marketing personalization, robust data engineering and infrastructure, scalable model deployment on secure cloud platforms, and continuous maintenance and support. With our guidance, you can leverage the transformative capabilities of AI to optimize operations, boost efficiency, and exceed goals. We enable you to unlock the full potential of AI with an approach grounded in transparency and purposeful innovation.',
      href: '/service#voice-search-optimization',
      src: '/images/service3.webp',
      category: 'ui_ux_design',
    },
    {
      title: 'Creative Design That Resonates ',
      subtitle: 'Our talented creative team partners with brands to craft compelling visual experiences that captivate audiences while powerfully amplifying messaging. From stunning animations to polished brand identities, we offer end-to-end services spanning logo, typography and color palette design, high-impact and conversion-focused website/app interfaces, engaging marketing materials and infographics, dynamic branded animations and motion graphics and strategic, story-driven video production, creating authentic experiences that form deep connections with your users and drive measurable results. Our creatives become an extension of your team to craft designs that distinguish your brand, resonate with your audience, and deliver ROI through visual storytelling that converts.',
      href: '/service#creative-design-that-resonates',
      src: '/images/service4.webp',
      category: 'ui_ux_design',
    },
  ];

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero
        title="RLAB GROUP <br/>CANADA"
        subtitle="Data tells a story, and we translate it into compelling narratives. Living at the intersection of AI-powered workflows and human ingenuity, RLAB dives deep to fuel your brand's journey, and whether you need robust website or marketing solutions, immersive AR/VR experiences, strategic consulting, or help dominating online spaces, we amplify your voice and reach to get you there."
        btnText="Start Here"
        btnLink="/contact"
        bgImageUrl="/images/landing-image.webp"
      />
      {/* End Hero Section */}

      {/* Start FunFact Section */}
      <div className="container">
        <FunFact
          variant="cs-type1"
          title="Powering Possibility with AI and Machine Learning"
          subtitle="We build stunning AI and ML-driven websites that enable unprecedented optimization, personalization and efficiency, where interactive platforms harness the power of NLP and sentiment analysis to hyper-target and delight every visitor, engaging audiences across devices, whether wearable, portable or embedded, including virtual storefronts and transaction systems."
          data={funfaceData}
        />
      </div>
      {/* End FunFact Section */}

      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="What we do"
          subtitle=""
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <Div className="row">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${
                index === 0 || index === 3 || index === 4
                  ? 'col-12'
                  : 'col-12'
              }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={item.href}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        <Div className="text-center">
          {portfolioData.length <= itemShow ? (
            ''
          ) : (
            <>
              <Spacing lg="65" md="40" />
              <span
                className="cs-text_btn"
                onClick={() => setItemShow(itemShow + 3)}
              >
                <span>Load More</span>
                <Icon icon="bi:arrow-right" />
              </span>
            </>
          )}
        </Div>
      </Div>

      {/* Start Awards Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_2">
        <Div className="cs-shape_2">
          <Div />
        </Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '0'}}>
              <SectionHeading
                title="Pioneering AI Innovation"
                subtitle=""
                variant="cs-style1"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginLeft: '0'}}>
              <TimelineSlider />
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Awards Section */}

      {/* Start Video Block Section */}
      <Spacing lg="130" md="70" />
      <Div className="container">
        <VideoModal
          bgUrl="/images/video_bg.jpeg"
        />
      </Div>
      {/* End Video Block Section */}

      {/* Start Team Section */}
      {/* <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="Awesome team <br/>members"
          subtitle="Our Team"
          variant="cs-style1"
        />
        <Spacing lg="85" md="45" />
        <TeamSlider />
      </Div> */}
      <Spacing lg="150" md="80" />
      {/* End Team Section */}

      {/* Start Testimonial Section */}
      {/* <TestimonialSlider /> */}
      {/* End Testimonial Section */}

      {/* Start Blog Section */}
      <Spacing lg="150" md="80" />
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Div className="container">
          <Div className="row">
            <Div className="col-xl-4">
              <SectionHeading
                title="See what‘s new on our Blog"
                subtitle="Our Blog"
                btnText="View More Blogs"
                btnLink="/blog"
              />
              <Spacing lg="90" md="45" />
            </Div>
            <Div className="col-xl-7 offset-xl-1">
              <Div className="cs-half_of_full_width">
                <PostSlider />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End Blog Section */}

      {/* Start MovingText Section */}
      <Spacing lg="125" md="70" />
      <MovingText text="Our reputed worldwide partners" />
      <Spacing lg="105" md="70" />
      {/* End MovingText Section */}

      {/* Start LogoList Section */}
      <Div className="container">
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Lets collaborate to create something exceptional together."
          btnText="Book a demo"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
